import { render } from "./Check130.vue?vue&type=template&id=93c7edd2&ts=true"
import script from "./Check130.vue?vue&type=script&lang=ts"
export * from "./Check130.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Zalo/CheckDB130_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__